import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "@components/atoms/typography";
import { GeneralSkeleton } from "@components/skeleton/skeleton";
import { loaderComponents } from "@components/molecules/baseLoader/variants";
import type { IBaseLoaderProps } from "@components/molecules/baseLoader/types";

export const BaseLoader = memo(function BaseLoader({
  type,
  isLoading,
  isError,
  children,
  style,
}: IBaseLoaderProps) {
  const { t } = useTranslation("form");

  const loader = useMemo(
    () =>
      type === "general" ? (
        <GeneralSkeleton style={style} />
      ) : (
        loaderComponents[type]
      ),
    [style, type],
  );

  if (isError) {
    return (
      <Typography
        center
        variant={"subtitle1"}
        color={"danger-dark"}
        className={"p-m5"}
      >
        {t("errors.serverError")}
      </Typography>
    );
  }

  if (isLoading) {
    return <>{loader}</>;
  }

  return <>{children}</>;
});
